<template>
    <header>
        <div
            class="header__image-container"
            v-if="backgroundImageUrl"
            :style="{ backgroundImage: `url(${backgroundImageUrl})` }"
        ></div>
        <h1
            class="header__title"
            v-if="entity"
        >{{ entity.name }}</h1>
    </header>
</template>

<script>
export default {
    props: {
        backgroundImageUrl: {
            default: null,
            required: false,
            type: String
        },
        entity: {
            default: null,
            required: false,
            type: Object
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

header {
    align-items: center;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    height: 100px;
    margin-bottom: 20px;
    overflow: hidden;

    & .header__image-container {
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        clip-path: polygon(0 0px, 80% 0, 100% 100%, 0px 100%);
        height: 100%;
        width: 110px;
    }

    & .header__title {
        color: #1c74a5;
        font-size: 20px;
        font-weight: 500;
        margin: 0 20px;
    }

    @media (--mq-large-min) {
        & .header__image-container {
            width: 220px;
        }
    }

    @media (--mq-full-min) {
        height: 150px;

        & .header__image-container {
            width: 330px;
        }

        & .header__title {
            font-size: 36px;
        }
    }
}
</style>
